import Alpine from "alpinejs";
import calculatedRow from "./components/calculatedRow";
import healthCareCalculator from "./components/healthCareCalculator";

window.addEventListener("load", () => {
    Alpine.data("healthCareCalculator", healthCareCalculator);
    Alpine.data("calculatedRow", calculatedRow);

    window.Alpine = Alpine;

    Alpine.start();
});
